module.exports = __webpack_public_path__ + "static/media/CICLO_2_PAZ_Y_COMUNIDAD_DIGITAL_DIGITAL_2022.1850aa02.jpg";